// removed by extract-text-webpack-plugin
module.exports = {"officeDescription":"_3kF_CjTwE_MkTe5va2JwAN"};


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/LocationsPage/LocationsList/LocationsList.scss
// module id = 803
// module chunks = 0